module.exports = __webpack_public_path__ + "img/hr-tree-07-d-leaves.133ae246.png";